<template>
  <div v-if="isShow" class="popup">
    <div class="popup_box">
      <p class="title">
        咨询意向单
        <i class="el-icon-close close" @click="cancel"></i>
      </p>
      <div class="form">
        <div class="form_row">
          <p class="label must">联系人</p>
          <el-input v-model.trim="name" placeholder="请输入联系人姓名" maxlength="50"></el-input>
        </div>
        <div class="form_row">
          <p class="label must">联系方式</p>
          <el-input v-model.trim="tel" placeholder="请输入手机号码" maxlength="20"></el-input>
        </div>
        <div class="form_row" style="height: 130px">
          <p class="label">备注信息</p>
          <el-input
            v-model.trim="remark"
            type="textarea"
            resize="none"
            placeholder="请填写备注信息"
            maxlength="200"
            show-word-limit
          ></el-input>
        </div>
      </div>
      <div class="submit_box">
        <el-button size="small" type="primary" @click="submit">确认</el-button>
        <el-button size="small" @click="cancel">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MessageBoard',
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['submit', 'cancel'],
  data() {
    return {
      name: '',
      tel: '',
      remark: '',
    };
  },
  created() {
    this.name = '';
    this.tel = '';
    this.remark = '';
  },
  methods: {
    cancel() {
      this.$emit('cancel', true);
    },
    submit() {
      if (this.name === '') {
        this.$message.error('请输入联系人');
        return false;
      }
      if (this.tel === '') {
        this.$message.error('请输入联系方式');
        return false;
      }
      this.$emit('submit', { name: this.name, tel: this.tel, remark: this.remark });
    },
  },
};
</script>

<style lang="scss" scoped>
.popup {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  .popup_box {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 640px;
    height: 420px;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.15);
    transform: translate(-50%, -50%);
  }
  .title {
    position: relative;
    height: 55px;
    padding-left: 24px;
    line-height: 55px;
    box-shadow: 0 1px 0 0 #eee;
  }
  .close {
    position: absolute;
    top: 0;
    right: 0;
    width: 55px;
    height: 55px;
    line-height: 55px;
    text-align: center;
    cursor: pointer;
  }
  .form {
    padding-top: 30px;
  }
  .form_row {
    display: flex;
    height: 32px;
    padding-left: 30px;
    margin-top: 24px;
    line-height: 32px;
    &:nth-child(1) {
      margin-top: 0;
    }
    /deep/ .el-input {
      width: 376px;
    }
    /deep/ .el-input__inner {
      width: 376px;
      height: 32px;
    }
    /deep/ .el-textarea {
      width: 376px;
    }
    /deep/ .el-textarea__inner {
      width: 376px;
      height: 130px;
      font-family: initial;
    }
    .label {
      position: relative;
      width: 128px;
      height: 32px;
      &.must {
        &::before {
          position: absolute;
          top: 0;
          left: -10px;
          color: #ff3b30;
          content: '*';
        }
      }
    }
  }
  .submit_box {
    padding: 15px 24px;
    margin-top: 30px;
    text-align: right;
    box-shadow: 0 -1px 0 0 #eee;
  }
}
</style>
